import type { Feature, Point } from 'geojson';
import { TrafikenConfig } from '../TrafikenConfig';
import { AjaxSource } from './AjaxSource';
import type { AjaxSourceOptions } from './Sources.types';

const defaultOptions = (region, cameraPageId) => ({
    id: 'traffic-camera-source',
    url: `${TrafikenConfig.infoLayerServiceBaseUrl}/api/trafficcameras?region=${region}${cameraPageId ? `&cameraArea=${cameraPageId}` : ''}`,
    displayName: 'Trafikkameror',
});

export interface TrafficCamera {
    pageId: string;
    wgs84Position: Point;
    name: string;
    url: string;
    imageUrl: string;
    source?: string;
    photoTime?: string;
}

export class TrafficCameraSource extends AjaxSource {
    constructor(region?: string, cameraPageId?: string, options?: AjaxSourceOptions) {
        super({ ...defaultOptions(region, cameraPageId), ...options });
    }

    parseData(cameras: TrafficCamera | TrafficCamera[]): Feature[] {
        if (!Array.isArray(cameras)) {
            cameras = [cameras];
        }
        return cameras.map((i) => ({
            id: i.pageId,
            type: 'Feature',
            geometry: i.wgs84Position,
            properties: i,
        }));
    }
}
